<template>
    <v-stage :config="Config.stage">
        <v-layer>
            <!-- 背景组 -->
            <v-group :config="Config.group">
                <v-rect :config="Config.rect"></v-rect>
                <v-text :config="Config.text"></v-text>
            </v-group>
            <!-- 遮罩层组 -->
            <v-group :config="Config.group">
                <v-rect :config="Config.coverRect" ref="coverRect"></v-rect>
                <v-text :config="Config.coverText" v-if="success"></v-text>
            </v-group>
            <!-- 滑块组 -->
            <v-group :config="Config.moveGroup" ref="moveGroup" @mouseup="moveGroupStop">
                <v-rect :config="Config.moveRect" ref="moveRect"></v-rect>
                <!-- 验证成功组 -->
                <v-group :config="Config.group" v-if="success">
                    <v-circle :config="Config.succCircle"></v-circle>
                    <v-line :config="Config.succLine"></v-line>
                </v-group>
                <v-group :config="Config.moveGroup_l" v-else>
                    <v-line :config="Config.moveLine1"></v-line>
                    <v-line :config="Config.moveLine2"></v-line>
                </v-group>
            </v-group>
        </v-layer>
    </v-stage>
</template>
<script>
export default {
    props: {
        captchaConfig: {
            type: Object
        }
    },
    data() {
        var captchaConfig = this.captchaConfig;
        var success = 0;
        var Config = {
            stage: {
                width: captchaConfig.width,
                height: captchaConfig.height
            },
            group: {
                x: 0,
                y: 0
            },
            rect: {
                width: captchaConfig.width,
                height: captchaConfig.height,
                fill: '#e8e8e8'
            },
            text: {
                x: 0,
                y: 0,
                width: captchaConfig.width,
                height: captchaConfig.height,
                text: this.$t('a_captchaTitle'),
                fontSize: 14,
                fontFamily: '微软雅黑',
                align: 'center',
                lineHeight: parseFloat(captchaConfig.height / 14)
            },
            //滑块组
            moveGroup: {
                draggable: true
            },
            moveRect: {
                x: 0.5,
                y: 0.5,
                width: captchaConfig.height - 1,
                height: captchaConfig.height - 1,
                fill: '#fff',
                stroke: '#8d92a1',
                strokeWidth: 1
            },
            moveGroup_l: {
                x: captchaConfig.height / 3,
                y: captchaConfig.height / 3
            },
            moveLine1: {
                x: 0,
                y: 0,
                points: [0, 0, captchaConfig.height / 6, captchaConfig.height / 6, 0, captchaConfig.height / 3],
                stroke: '#8d92a1',
                strokeWidth: 1,
                lineCap: 'round',
                lineJoin: 'round'
            },
            moveLine2: {
                x: captchaConfig.height / 6,
                y: 0,
                points: [0, 0, captchaConfig.height / 6, captchaConfig.height / 6, 0, captchaConfig.height / 3],
                stroke: '#8d92a1',
                strokeWidth: 1,
                lineCap: 'round',
                lineJoin: 'round'
            },
            //创建遮罩层组
            coverRect: {
                width: captchaConfig.height / 2,
                height: captchaConfig.height,
                fill: '#8d92a1',
                opacity: 0.8
            },
            coverText: {
                x: 0,
                y: 0,
                width: captchaConfig.width - captchaConfig.height,
                height: captchaConfig.height,
                align: 'center',
                text: this.$t('a_captchaSuccess'),
                fontSize: 14,
                fontFamily: '微软雅黑',
                fontStyle: 'bold',
                fill: '#fff',
                lineHeight: parseFloat(captchaConfig.height / 14)
            },
            //验证成功组
            succCircle: {
                x: captchaConfig.height / 2,
                y: captchaConfig.height / 2,
                radius: captchaConfig.height / 4,
                fill: '#8d92a1'
            },
            succLine: {
                points: [captchaConfig.height / 2 - captchaConfig.height / 4 / 2, captchaConfig.height / 2, captchaConfig.height / 2 - captchaConfig.height / 4 / 8, captchaConfig.height / 2 + captchaConfig.height / 4 / 2, captchaConfig.height / 2 + captchaConfig.height / 4 / 2, captchaConfig.height / 2 - captchaConfig.height / 4 / 2],
                stroke: '#fff',
                strokeWidth: 1,
                lineCap: 'round',
                lineJoin: 'round'
            }
        };
        return {
            Config,
            success
        };
    },
    mounted() {
        this.$refs.moveGroup.getNode().dragBoundFunc(pos => {
            var captchaConfig = this.captchaConfig;
            var moveGroup = this.$refs.moveGroup.getNode();
            var moveRect = this.$refs.moveRect.getNode();
            var coverRect = this.$refs.coverRect.getNode();

            var moveX = moveGroup.getAttrs().x ? moveGroup.getAttrs().x : 0;
            coverRect.width(moveX + captchaConfig.height / 2);
            if (pos.x >= captchaConfig.width - captchaConfig.height) {
                if (this.success == 0) {
                    this.$emit('eventCaptcha', 1);
                }
                this.success = 1;
                coverRect.opacity(1);
            }
            if (this.success == 0) {
                if (pos.x < 0) {
                    return {
                        x: 0,
                        y: moveGroup.getAbsolutePosition().y
                    };
                } else if (pos.x > captchaConfig.width - captchaConfig.height) {
                    return {
                        x: captchaConfig.width - captchaConfig.height,
                        y: moveGroup.getAbsolutePosition().y
                    };
                } else {
                    return {
                        x: pos.x,
                        y: moveGroup.getAbsolutePosition().y
                    };
                }
            } else {
                return {
                    x: captchaConfig.width - captchaConfig.height,
                    y: moveGroup.getAbsolutePosition().y
                };
            }
        });
    },
    methods: {
        moveGroupStop() {
            if (this.success == 0) {
                this.$refs.moveGroup.getNode().to({
                    x: 0,
                    duration: 0.3
                });
                this.$refs.coverRect.getNode().to({
                    width: this.captchaConfig.height / 2,
                    duration: 0.3
                });
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/login/components/Captcha.vue